import JsonLd from 'marketplace-ui-common/components/elements/JsonLd';
import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import { useMemo } from 'react';
import { useReviews } from 'marketplace-ui-reviews/hooks/useReviews';
import ReviewFilters from 'marketplace-ui-reviews/records/ReviewFilters';
import { useAppContext } from '../context/AppContext';
import { Paths } from '../constants/paths';
import { getFullPublicUrl } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export function ListingDetailsStructuredData({
  unifiedDetailsData
}) {
  var _reviewStats$axes, _reviewStats$axes$get;
  const appContext = useAppContext();

  // Get review stats for rating data
  const offeringId = (unifiedDetailsData === null || unifiedDetailsData === void 0 ? void 0 : unifiedDetailsData.offeringId) || 0;
  const reviewFilters = useMemo(() => new ReviewFilters({
    entityId: offeringId,
    limit: 2
  }), [offeringId]);
  const {
    reviewStats,
    reviewsCount
  } = useReviews({
    appContext,
    reviewFilters,
    offeringId,
    reviewType: 'APP'
  });

  // Extract rating data from reviewStats
  const overallAxis = reviewStats === null || reviewStats === void 0 || (_reviewStats$axes = reviewStats.axes) === null || _reviewStats$axes === void 0 || (_reviewStats$axes$get = _reviewStats$axes.get) === null || _reviewStats$axes$get === void 0 ? void 0 : _reviewStats$axes$get.call(_reviewStats$axes, 'OVERALL');
  const averageRating = overallAxis === null || overallAxis === void 0 ? void 0 : overallAxis.average;
  const reviewCount = reviewsCount;
  const structuredData = useMemo(() => {
    var _screenshots$;
    if (!(unifiedDetailsData !== null && unifiedDetailsData !== void 0 && unifiedDetailsData.name) || !(unifiedDetailsData !== null && unifiedDetailsData !== void 0 && unifiedDetailsData.urlSlug)) {
      return null;
    }
    const {
      name,
      category = [],
      productType,
      tagline,
      screenshots = [],
      listingIcon,
      companyName,
      features = [],
      urlSlug
    } = unifiedDetailsData;

    // Get the first screenshot URL
    const screenshotUrl = (_screenshots$ = screenshots[0]) === null || _screenshots$ === void 0 || (_screenshots$ = _screenshots$.screenshot) === null || _screenshots$ === void 0 ? void 0 : _screenshots$.value;

    // Get feature titles as comma-delimited string
    const featureList = features.map(feature => feature.featureName).filter(Boolean).join(', ');

    // Build the structured data object
    const data = {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name,
      applicationCategory: category[0],
      // Primary category
      applicationSubCategory: category[1],
      // Secondary category if available
      additionalType: productType,
      description: tagline,
      thumbnailUrl: listingIcon === null || listingIcon === void 0 ? void 0 : listingIcon.value,
      url: getFullPublicUrl(Paths.LISTING_DETAILS.replace(':listingSlug', urlSlug)),
      requirements: 'Compatible with HubSpot',
      operatingSystem: 'Web'
    };

    // Add optional fields only if they have values
    if (screenshotUrl) {
      data.screenshot = screenshotUrl;
    }
    if (companyName) {
      data.creator = {
        '@type': 'Organization',
        name: companyName
      };
    }
    if (featureList) {
      data.featureList = featureList;
    }

    // Add aggregate rating if available
    if (averageRating && reviewCount) {
      data.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: averageRating,
        reviewCount
      };
    }
    return data;
  }, [unifiedDetailsData, averageRating, reviewCount]);
  if (!structuredData) {
    return null;
  }
  return /*#__PURE__*/_jsx(DocumentHead, {
    children: /*#__PURE__*/_jsx(JsonLd, {
      item: structuredData
    })
  });
}